import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { filter, skip, takeUntil } from 'rxjs/operators';
import { createWorkspace } from '../../../organisation/organisation.actions';
import {
  selectCurrentOrganizationID,
  selectNewWorkspaceLoadingState,
} from '../../../organisation/organisation.selector';
import { Router } from '@angular/router';

export interface NewWorkspaceData {
  name: string;
  email: string;
}

@Component({
  selector: 'nw-new-workspace-modal',
  templateUrl: './new-workspace-modal.component.html',
  styleUrls: ['./new-workspace-modal.component.scss'],
})
export class NewWorkspaceModalComponent implements OnInit, OnDestroy {
  @Output() cancel = new EventEmitter<void>();

  workspaceName = '';
  email = '';
  loadingState$ = this.store.select(selectNewWorkspaceLoadingState);

  currentOrgId$ = this.store.select(selectCurrentOrganizationID);
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly store: Store,
    private router: Router,
  ) {}

  ngOnInit() {
    // Close modal when loading state changes to 'idle' (success)
    this.loadingState$
      .pipe(
        takeUntil(this.destroy$),
        skip(1), // Skip initial value
        filter(state => state === 'idle'),
      )
      .subscribe(() => {
        // -- //
      });

    this.currentOrgId$
      // .pipe(
      //   takeUntil(this.destroy$),
      //   filter(id => !!id),
      // )
      .subscribe(id => {
        console.log('currentOrgId', id);
      });

    this.currentOrgId$.pipe(takeUntil(this.destroy$)).subscribe(id => {
      if (id) {
        this.router.navigate(['org', id]);
        this.cancel.emit();
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onClose() {
    this.cancel.emit();
  }

  onSubmit() {
    const name = this.workspaceName.trim();
    const email = this.email.trim();
    this.store.dispatch(createWorkspace({ name, email }));
  }
}
